export default __webpack_public_path__ + "static/media/sneha.d7204c2a.jpg";